import Vue from 'vue';
import App from '@/App.vue';
import store from '@/store';
import router from '@/router';
import ApiService from '@/common/api.service';
import Lang from 'vuejs-localization';
import VCalendar from 'v-calendar';
import 'v-calendar/lib/v-calendar.min.css';
import VeeValidate from 'vee-validate';
import { config } from '@/config/validations';
import VueCookies from 'vue-cookies';
import Snotify from 'vue-snotify';
import 'vue-snotify/styles/material.css';
import VueSlider from 'vue-slider-component';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VModal from 'vue-js-modal';
import smoothscroll from 'smoothscroll-polyfill';
import VueAnalytics from 'vue-analytics';
import VueGtm from "vue-gtm";
import SweetAlertIcons from 'vue-sweetalert-icons';

Vue.config.productionTip = false;
// Add global/prototype variable for expense type
Vue.prototype.$CHILD_EXPENSE_TYPE = 'EXPENSE_TYPE_CHILD_MAINTENANCE';
Vue.prototype.$ALIMONY_EXPENSE_TYPE = 'EXPENSE_TYPE_SPOUSAL_MAINTENANCE';
Vue.prototype.$SHARED_EXPENSE_TYPE = 'EXPENSE_TYPE_SHARED_EXPENSES';

ApiService.init();
Lang.requireAll(require.context('./lang', true, /\.js$/));

Vue.use(Lang);
Vue.use(VCalendar, {
  firstDayOfWeek: 1,
  titlePosition: "left",
});

Vue.use(VeeValidate, config);

Vue.use(VueCookies);
Vue.use(Snotify, {
  toast: {
    timeout: 3500
  }
});

Vue.use(VueAnalytics, {
  id: 'UA-149972260-2',
  router,
});

Vue.use(VueGtm, {
  id: "GTM-T95W2BD",
  defer: false,
  enabled: true,
  debug: true,
  loadScript: true,
  vueRouter: router,
  trackOnNextTick: false,
});

Vue.use(VueSlider);
Vue.use(VModal);
Vue.use(Loading);
Vue.use(SweetAlertIcons);

smoothscroll.polyfill();

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app');
